import { router } from '@/main/router';
import { Path } from '@/main/router/routerPath';
import NotFound from '@/main/pages/NotFound.vue';
//import AccessDenied from '@/main/pages/AccessDenied.vue';
import Home from '@/main/pages/Home.vue';
import { Kartoteka } from '@/modules/kartoteka';
import { Crm } from '@/modules/crm';
import { NoveVozy } from '@/modules/noveVozy';
import { Pujcovna } from '@/modules/pujcovna';
import { Sklad } from '@/modules/sklad';
import { Administrace } from '@/modules/administrace';
import { Servis } from '@/modules/servis';
import { Ciselniky } from '@/modules/ciselnik';
import { Uzaverka } from '@/modules/uzaverka';
import { OjeteVozy } from '@/modules/ojeteVozy';
import { OjeteVozyExternal } from '@/modules/ojeteVozyExternal';
import { Uctenky } from '@/modules/uctenky';
import { Sestavy } from '@/modules/sestavy';
import { Oem } from '@/modules/oem';
import { WmsModule } from '@/modules/wmsModule';
import { Accounting } from '@/modules/Accounting';
import SessionOver from '@/main/pages/SessionOver.vue';

import DmsDevLocalizationKey from '#components/dms/DevLocalizationKey.vue';

export { router };

router.addRoutes([
	new Path('/').addChildren([
		Crm.router,
		Kartoteka.router,
		NoveVozy.router,
		OjeteVozy.router,
		OjeteVozyExternal.router,
		Sklad.router,
		Administrace.router,
		Servis.router,
		Pujcovna.router,
		Ciselniky.router,
		Uzaverka.router,
		Uctenky.router,
		Sestavy.router,
		Oem.router,
		WmsModule.router,
		Accounting.router,
		{ path: '', component: Home, name: 'home' },
		new Path('dev/localization', DmsDevLocalizationKey),

		// new Path('*', NotFound),
		// new Path('accessdenied', AccessDenied,'accessdenied'),
	]),
	{
		path: '/session-over',
		component: SessionOver,
		name: 'SessionOver'
	},
	{ path: '*', component: NotFound }
]);

/**
 * This is used as a hack to normalize URL letter case by redirecting the URL once after the page loads.
 *
 * There is no way (that I know of) to do this correctly without implementing some form of custom
 * route matching, ie. reimplementing Vue Router's functionality.
 *
 * This hack is needed only when the page is loaded, subsequent page navigation uses named
 * routes, so the correct letter cases will be used.
 */
const unregister = router.beforeEach((to, from, next) => {
	unregister();
	if (to.name) {
		next({ name: to.name, params: to.params, query: to.query, replace: true });
	} else {
		next();
	}
});
